import { Fragment } from 'react';
import { t } from '@lingui/core/macro';
import { Trans } from '@lingui/react/macro';
import { Button, Loader, Menu } from '@pocketlaw/tetris';
import { Falcon } from '@pocketlaw/tetris/macro';
import { DialogState } from 'shared/domains/common-ui/DialogState';
import { useDownloadCSV } from './useDownloadCSV';
export function CSVDownload() {
    const { download, loading, progress, cancel } = useDownloadCSV();
    return (<Fragment>
      <DialogState onClose={cancel} state={{ loading }} loading={{
            title: t({
                message: `Downloading ${progress}%`,
                comment: 'Title on status dialog when downloading search result',
            }),
            description: t({
                message: 'Wait while we download the data for you.',
                comment: 'Description on status dialog when downloading search result',
            }),
            actions: (<Button type="button" appearance="secondary" onClick={cancel} size="xs">
              <Trans comment="Cancel search result CSV download">Cancel</Trans>
            </Button>),
        }}/>

      <Menu.Root target={<Button type="button" size="xs" disabled={loading} appearance="secondary">
            {loading ? <Loader /> : <Falcon icon="download"/>}
            <Trans comment="CSV download button: Label">Download</Trans>
          </Button>}>
        <Menu.Item onClick={() => download({ prettifyValues: true })}>
          <Menu.ItemText primary={t({ message: 'With display names', comment: 'CSV Download: formatted export option label' })} secondary={t({
            message: 'Names and labels are shown instead of IDs, e.g. user names instead of user IDs.',
            comment: 'CSV Download: formatted export option description',
        })}/>
        </Menu.Item>
        <Menu.Item onClick={() => download({ prettifyValues: false })}>
          <Menu.ItemText primary={t({ message: 'With raw IDs', comment: 'CSV Download: raw export option label' })} secondary={t({
            message: 'Original values as stored in the system, e.g. user IDs instead of names.',
            comment: 'CSV Download: raw export option description',
        })}/>
        </Menu.Item>
      </Menu.Root>
    </Fragment>);
}
